const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.54 0H6.46a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h11.08a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3Zm1 21a1 1 0 0 1-1 1H6.46a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h1.31l.11.34A2.08 2.08 0 0 0 9.9 4h4.2a2.08 2.08 0 0 0 2-1.66l.13-.34h1.31a1 1 0 0 1 1 1Z" fill="currentColor"></path></svg>';
export {
  a as default
};
